import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=90ac3b3e&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90ac3b3e')) {
      api.createRecord('90ac3b3e', component.options)
    } else {
      api.reload('90ac3b3e', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=90ac3b3e&", function () {
      api.rerender('90ac3b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/Settings.vue"
export default component.exports